<template>
    <div class='speaker-page page'>
        <span class='page-header'>Records list</span>
        <span class='loading-title speaker-page__loading-title' v-if='isLoading'>Загрузка</span>
        <div class='records-list'>
        	<Record 
       		 	v-for='(record, index) in records' 
                v-bind:key='record.id'
        		v-bind:record='record'
        		v-bind:index='index'
                v-on:switch='switchOnOff'
        	/>
        </div>
    </div>
</template>

<script>
import Record from '@/components/Record.vue'

export default {
	name: 'RecordList',
	components: {
		Record
	},
    data: function() {
        return {
            isLoading: false,
        	records: []
        }
    },
    methods: {
        switchOnOff: function(index) {
            this.records = this.records.map(function(item, i) {
                return {
                    record: item.record,
                    name: item.name,
                    duration: item.duration,
                    isActive: i == index ? true : false
                }
            });
        },
        getRecords: function() {
            fetch('https://voicy-speaker.herokuapp.com/voices')
                .then(response => { 
                    return response.json();
                }).then(response => {
                    console.log(response);
                    let temp = response.map((item, index) => {
                        if(item.audioBlob.length > 0) {
                            const audioBlob = new Blob([new Uint8Array(item.audioBlob[0].data).buffer] );
                            if(audioBlob.size > 0) {
                                const audioUrl = URL.createObjectURL(audioBlob);
                                const audio = new Audio(audioUrl);

                                const fullDate = new Date(item.timeStamp);
                                const hours = fullDate.getHours() > 9 ? fullDate.getHours() : '0' + fullDate.getHours();
                                const minutes = fullDate.getMinutes() > 9 ? fullDate.getMinutes() : '0' + fullDate.getMinutes();
                                const seconds = fullDate.getSeconds() > 9 ? fullDate.getSeconds() : '0' + fullDate.getSeconds();
                                const time = hours + ":" + minutes + ":" + seconds;

                                const day = fullDate.getDate() > 9 ? fullDate.getDate() : '0' + fullDate.getDate();
                                const month = fullDate.getMonth() > 9 ? (fullDate.getMonth() + 1) : '0' + (fullDate.getMonth() + 1);
                                const date = day + '.' + month + '.' + fullDate.getFullYear(); 

                                return {
                                    record: audio,
                                    name: time + "  " + date,
                                    duration: audio.duration,
                                    isActive: false
                                }
                            }
                        }
                    })

                    this.records = temp.filter(item => {
                        if(item != undefined) {
                            return true;
                        } else return false;
                    }).reverse();

                    this.isLoading = false;
                });
        }
    },
    beforeMount: function() {
        this.isLoading = true;
        this.getRecords();
        this.$emit('changeLoading');
    }
}
</script>

<style lang='less'>
.records-list {
    height: calc(100% - 79px);
    overflow-y: scroll;
    margin-top: 28px;
}

.loading-title {
    font-size: 30pt;
    font-family: Roboto;
    color: #41B883;
}

.speaker-page {
    &__loading-title {
        margin-top: 50%;
    }
}
</style>